export default __webpack_public_path__ + "static/media/logo-awa-dark.64ee2b50.svg";